export default "__VITE_ASSET__f0ae40c4__"